import { Injectable } from '@angular/core';
import { GeneralConstants } from '../constants/general.constants';
import { RestService } from './rest.service';
import { NotificationService } from './notification.service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ComisionesService {
  constructor(
    private restService: RestService,
    private notificationService: NotificationService,
    public http: HttpClient
  ) {}

  public getCashIn = async () => {
    try {
      const response = await this.restService.get(GeneralConstants.getCashin);
      return response;
    } catch (e) {
      this.notificationService.mgsView({
        error: null,
        messenger: 'No pudimos traer los motivos de consulta, por favor intentá en unos minutos.',
        title: '',
        type: 2,
        configNotification: null
      });
    }
  };

  public getCashOut = async () => {
    try {
      const response = await this.restService.get(GeneralConstants.getCashout);
      return response;
    } catch (e) {
      this.notificationService.mgsView({
        error: null,
        messenger: 'No pudimos traer los motivos de consulta, por favor intentá en unos minutos.',
        title: '',
        type: 2,
        configNotification: null
      });
    }
  };
}
